import { createContext, SetStateAction } from 'react';
import { IExpandContext } from './expand.props';

export const BILLING_METHOD = {
  CONCRETE: 100000000,
  FICTITIOUS: 100000001
} as const;

export const CASE_TYPE = {
  LESS_DAMAGE: 100000006,
  OWN_DAMAGE: 100000000,
  COMPREHENSIVE_INSURANCE_DAMAGE: 100000002,
  PARTIAL_INSURANCE_DAMAGE: 100000001,
  THIRD_PARTY_DAMAGE: 100000004,
  LIABILITY_DAMAGE: 100000003,
  QUESTION_OF_GUILT_UNCLEAR: 100000005,
  BREAKDOWN: 100000007
};

export function isPhotoRequired(thirdPartyDamageBillingMethod: number | null, caseType: number | null) {
  return (
    (thirdPartyDamageBillingMethod === BILLING_METHOD.FICTITIOUS || thirdPartyDamageBillingMethod === null) &&
    caseType === CASE_TYPE.THIRD_PARTY_DAMAGE
  );
}

export function isBillingMethodConcrete(thirdPartyDamageBillingMethod: number | null) {
  return thirdPartyDamageBillingMethod === BILLING_METHOD.CONCRETE;
}

export const ExpandContext = createContext<IExpandContext>({
  incidentId: '',
  toggleExpand: () => console.error('No toggleExpand function in ExpandContext.'),
  row: {},
  isIncedentSubmiting: false,
  setIsIncidentSubmiting: function (value: SetStateAction<boolean>): void {
    throw new Error('Function not implemented.');
  },
  isIncedentSubmitingError: false,
  setIsIncidentSubmitingError: function (value: SetStateAction<boolean>): void {
    throw new Error('Function not implemented.');
  },
  showValidationScreen: false,
  setShowValidationScreen: function (value: SetStateAction<boolean>): void {
    throw new Error('Function not implemented.');
  }
});

export const diffDatesModalFields = {
  step2: {
    upperText:
      'Der von Ihnen gewählte Wiedervorlagetermin liegt später als der zuvor gewählte Vorbesichtigungstermin am',
    lowerText:
      ' Bitte wählen Sie einen neuen Vorbesichtigungstermin aus, andernfalls wird das alte Vorbesichtigungstermin mit dem Wiedervorlagetermin gleichgesetzt.',
    upperTitle: 'Neue Vorbesichtigungstermin',
    lowerTitle: 'Alte Vorbesichtigungstermin mit dem Wiedervorlagetermin gleichgesetzen.'
  },
  step4: {
    upperText: 'Der von Ihnen gewählte Wiedervorlagetermin liegt später als der zuvor gewählte Abholtermin am',
    lowerText:
      ' Bitte wählen Sie einen neuen Abholtermin aus, andernfalls wird das alte Abholtermin mit dem Wiedervorlagetermin gleichgesetzt.',
    upperTitle: 'Neue Abholtermin',
    lowerTitle: 'Alte Abholtermin mit dem Wiedervorlagetermin gleichgesetzen.'
  },
  step5: {
    upperText:
      'Der von Ihnen gewählte Wiedervorlagetermin liegt später als der zuvor gewählte Fertigstellungstermin am',
    lowerText:
      ' Bitte wählen Sie einen neuen Fertigstellungstermin aus, andernfalls wird das alte Fertigstellungstermin mit dem Wiedervorlagetermin gleichgesetzt.',
    upperTitle: 'Neue Fertigstellungstermin',
    lowerTitle: 'Alte Fertigstellungstermin mit dem Wiedervorlagetermin gleichgesetzt.'
  }
};

export const INFO_HINT_DELAYED_INCIDENT_DATE = 'Diese Information ist für den Kunden sichtbar.';
